// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout_HeFKA","content":"Layout_content_1-jmt","header":"Layout_header_3qTVX"};